module.exports = __webpack_public_path__ + "static/media/gestao_economia.15d84600.png";